import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { CircularProgress, Box } from "@mui/material";
import { hasLeaveRole } from "../services/api";
import UnauthorizedPage from "../pages/Unauthorized";

/**
 * AdminRoute component
 * Protects routes that require ADMIN role
 * Redirects to login if not authenticated
 * Shows unauthorized page if authenticated but not admin
 */
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Check if user has ADMIN role
  const isAdmin = hasLeaveRole(user, "ADMIN");

  if (!isAdmin) {
    return <UnauthorizedPage />;
  }

  return <>{children}</>;
};

export default AdminRoute;
